<script>
/* eslint-disable */

import noteIcon from "../../../static/assets/images/note-1.svg";
import noteIconActive from "../../../static/assets/images/note-2.svg";
import flagIcon1 from "../../../static/assets/images/flag-1.svg";
import flagIcon2 from "../../../static/assets/images/flag-2.svg";
import flagIcon3 from "../../../static/assets/images/flag-3.svg";
import altLinkIcon from "../../../static/assets/images/external-link-alt-solid.svg";
import chefHatIcon from "../../../static/assets/images/icon-recipe.svg";
export default {
  name: "Controlbar",
  data() {
    return {
      switchToken: null,
      memberUrl: process.env.VUE_APP_MEMBER_BASE_URL,
      noteIcon,
      noteIconActive,
      altLinkIcon,
      chefHatIcon,
      flagsListIcons: [flagIcon1, flagIcon2, flagIcon3],
      id: null,
      typeTitle: "Workout",
      statuses: {
        draft: {
          key: "ready-to-film",
          label: "READY TO FILM",
        },
        "ready-to-film": {
          key: "clip-listed",
          label: "CLIP LISTED",
        },
        "clip-listed": {
          key: "filmed",
          label: "FILMED",
        },
        filmed: {
          key: "post-production",
          label: "POST PRODUCTION ",
        },
        "post-production": {
          key: "produced",
          label: "FOR APPROVAL",
        },
        produced: {
          key: "approved",
          label: "APPROVED  ",
        },
      },
    };
  },
  computed: {
    currentRecipe() {
      return this.$store.getters[`recipes/currentRecipe`];
    },
    activityCurrentTab() {
      return this.$store.getters[`${this.currentType}/activityCurrentTab`];
    },
    currentActivity() {
      return this.$store.getters[`${this.currentType}/currentActivity`];
    },
    startTabErrors() {
      return this.$store.getters[`${this.currentType}/startTabErrors`];
    },
    seriesOptions() {
      return this.$store.getters[`${this.currentType}/seriesOptions`];
    },
    coloursOptions() {
      return this.$store.getters[`${this.currentType}/coloursOptions`];
    },
    notesOpened() {
      return this.$store.getters[`${this.currentType}/notesOpened`];
    },
    currentFlag() {
      return this.$store.getters[`${this.currentType}/currentFlag`];
    },
    flagsList() {
      return this.$store.getters[`${this.currentType}/flagsList`];
    },
    activeColour() {
      return this.coloursOptions && this.currentActivity.colour
        ? this.coloursOptions.find(
            (option) => option.id == this.currentActivity.colour
          )
        : null;
    },
    activeFlag() {
      if (
        this.currentActivity.flag_intensity != null &&
        this.currentActivity.flag_intensity != 0
      ) {
        return this.flagsListIcons[this.currentActivity.flag_intensity - 1];
      }
      return this.flagsListIcons[0];
    },
    currentRoute() {
      if (this.$route) return this.$route.path ? this.$route : null;
    },
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          this.typeTitle = "Warmup";
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          this.typeTitle = "Stretch Flow";
          return "stretchflows";
        }
      }
      this.typeTitle = "Workout";
      return "workouts";
    },
  },
  methods: {
    createActivity() {
      this.$store
        .dispatch(
          `${this.currentType}/createEmptyActivity`,
          this.currentActivity
        )
        .then(
          (res) => {
            this.getToasterResponse();
          },
          (error) => {
            console.log(error);
          }
        );
    },
    updateActivity(status = "draft") {
      this.$store.commit(`${this.currentType}/setActivityStatus`, status);
      this.$store
        .dispatch(`${this.currentType}/updateActivity`, this.$route.params.id)
        .then(
          (res) => {
            if (this.activityCurrentTab == 6) {
              console.log("ters");
              this.updateProduction();
            } else {
              this.getToasterResponse();
            }
          },
          (error) => {
            console.log(error);
          }
        );
    },
    updateProduction() {
      this.$store
        .dispatch(`${this.currentType}/updateProduction`, this.$route.params.id)
        .then((res) => {
          this.$store.dispatch(
            `${this.currentType}/updateVideo`,
            this.$route.params.id
          );

          this.getToasterResponse();
        });
    },
    getToasterResponse() {
      if (this.startTabErrors.working_title) {
        this.makeToast("danger", "Error", this.startTabErrors.working_title);
      }
      if (this.startTabErrors.series) {
        this.makeToast("danger", "Error", this.startTabErrors.series);
      }
      if (this.startTabErrors.colour) {
        this.makeToast("danger", "Error", this.startTabErrors.colour);
      }
      if (
        this.startTabErrors.working_title == null &&
        this.startTabErrors.series == null &&
        this.startTabErrors.colour == null
      ) {
        // this.makeToast("success", "Success", `Succesfully saved.`);
        this.$store.commit(`commons/setSavingForm`, "Saved");
      }
    },
    makeToast(variant = null, title, message) {
      this.$bvToast.toast(message, {
        title: `${title || "default"}`,
        variant: variant,
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
    open() {
      this.$store.commit(`${this.currentType}/setOpenedNotes`, true);
    },
    updateFlag() {
      const flag =
        this.currentActivity.flag_intensity == 3
          ? 1
          : this.currentActivity.flag_intensity + 1;

      this.$store.commit(`${this.currentType}/setCurrentFlag`, flag);
      this.$store.dispatch(
        `${this.currentType}/updateActivity`,
        this.$route.params.id
      );
    },
    openApproval(status) {
      this.$store.commit(`${this.currentType}/setOpenedApproval`, true);
      this.$store.commit(`${this.currentType}/setStatusApproval`, status);
    },

    createRecipe() {
      this.$store.dispatch("recipes/createRecipe", this.currentRecipe).then(
        (res) => {
          this.getRecipeToasterResponse();
        },
        (error) => {
          console.log(error);
        }
      );
    },
    updateRecipe(status) {
      this.$store.commit(`recipes/setRecipeStatus`, status);
      this.$store.dispatch("recipes/updateRecipe", this.$route.params.id).then(
        (res) => {
          // this.makeToast("success", "Success", `Succesfully saved.`);
          this.$store.commit(`commons/setSavingForm`, "Saved");
        },
        (error) => {
          console.log(error);
        }
      );
    },
    getRecipeToasterResponse() {
      if (this.recipeErrors.title) {
        this.makeToast("danger", "Error", this.recipeErrors.title);
      }
      if (this.recipeErrors.description) {
        this.makeToast("danger", "Error", this.recipeErrors.description);
      }
      if (
        this.recipeErrors.title == null &&
        this.recipeErrors.description == null
      ) {
        // this.makeToast("success", "Success", `Succesfully saved.`);
        this.$store.commit(`commons/setSavingForm`, "Saved");
      }
    },
    previewActivityMember() {
      this.$store.dispatch(`user/getSwtichToken`).then(
        (res) => {
          const activityType =
            this.currentActivity.type == "stretch_flow"
              ? "stretch-flow"
              : this.currentActivity.type;
          window.open(
            `${this.memberUrl}/switch/${res.frontend.token}/?next=/move/${activityType}/view/${this.currentActivity.id}`,
            "_blank"
          );
        },
        (error) => {
          console.log(error);
        }
      );
    },
    previewRecipeMember() {
      this.$store.dispatch(`user/getSwtichToken`).then(
        (res) => {
          window.open(
            `${this.memberUrl}/switch/${res.frontend.token}/?next=/eat/view/${this.currentRecipe.id}`,
            "_blank"
          );
        },
        (error) => {
          console.log(error);
        }
      );
    },
    dropDownTextStatus(status) {
      if (status == "approved") {
        return "APPROVED AND PAUSE";
      }

      if (status == "published") {
        return "APPROVED AND PUBLISH";
      }

      return "FOR APPROVAL";
    },
  },
  mounted() {
    this.$store.commit(`${this.currentType}/setOpenedNotes`, false);
    this.id = this.$route.params.id ? this.$route.params.id : null;
    if (localStorage.getItem("switchToken")) {
      this.token = localStorage.getItem("switchToken");
    }
  },
};
</script>

<style lang="scss">
.header-title {
  background: #f5f4f4;
  padding: 15px 25px;
  box-shadow: 0px 4px 8px #00000014;
  top: 64px;
  position: fixed !important;
  width: 100%;
  height: 72px;
  z-index: 11;
  .preview-shortcut {
    vertical-align: text-top;
    padding: 0 8px;
    img {
      width: 15px;
    }
  }
  .title {
    .color {
      width: 38px;
      height: 38px;
      border-radius: 8px;
      margin-right: 15px;

      &.default {
        background: #efefef;
      }
    }
    h2 {
      font-size: 24px;
      margin: 0;
      padding-right: 10px;
    }
    span {
      margin: 0;
      font-size: 16px;
      color: #767676;
    }
  }

  .save {
    p {
      width: 280px;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.4);
      padding-right: 10px;
      margin: 0;
    }
  }

  .status-badge {
    span {
      border-radius: 24px;
      background: #e3e3e3;
      font-size: 12px;
      color: #1b1c1d;
      display: block;
      padding: 10px 20px;
      font-family: "Lato-Bold";
      text-transform: uppercase;
    }
  }
}

.icons {
  span {
    width: 22px;
    height: 22px;
    background-position: center !important;
    background-size: cover !important;
    display: inline-block;
    margin-right: 10px !important;
    cursor: pointer;
    &.notes {
      &.w-hover {
        &:hover {
          background: url("/static/assets/images/note-1-hover.svg") !important;
          background-position: center !important;
          background-size: cover !important;
          display: inline-block;
        }
      }
    }
  }
}
.fixed-spacing {
  height: 70px;

  &.title-active {
    height: 150px;
  }
}
.dropdown-button {
  .btn {
    text-transform: uppercase;
    min-width: 220px;
    &.dropdown-toggle {
      border-left: 1px solid white;
      min-width: auto;
      &:after {
        margin-left: 0;
        border-top: 0;
        border-left: 0;
        border-right: 1px solid #fff !important;
        border-bottom: 1px solid #fff !important;
        width: 10px;
        height: 10px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin-top: 0;
      }
    }
  }

  .dropdown-menu {
    right: 0;
    font-size: 14px;
    font-family: "Lato-Bold";
  }
}
</style>

<template>
  <div>
    <div
      class="
        header-title
        save-container
        d-flex
        justify-content-between
        align-items-center
      "
      v-if="
        currentRoute.path != '/' &&
        currentRoute.path != '/todo' &&
        currentRoute.path.indexOf('recipe') !== 0 &&
        currentRoute.path != '/recipes' &&
        currentRoute.path != '/learn/create' &&
        currentRoute.path != '/analytics' 
      "
    >
      <div class="title d-flex justify-content-between align-items-center">
        <div class="icons pt-2" v-if="currentActivity.id">
          <span
            class="px-2 flag"
            :style="{ backgroundImage: 'url(\'' + activeFlag + '\')' }"
            @click="updateFlag()"
          ></span>
          <span
            v-if="!currentActivity.flag_internal_notes"
            class="px-2 notes w-hover"
            :style="{ backgroundImage: 'url(\'' + noteIcon + '\')' }"
            @click="open()"
          ></span>
          <div class="tooltip-wrapper">
            <span
              v-if="currentActivity.flag_internal_notes"
              class="px-2 has-note"
              :style="{ backgroundImage: 'url(\'' + noteIconActive + '\')' }"
              @click="open()"
            ></span>
            <div class="data" v-if="currentActivity.flag_internal_notes">
              {{ currentActivity.flag_internal_notes }}
            </div>
          </div>
        </div>
        <div
          class="color"
          v-if="activeColour"
          :style="{ background: activeColour.value }"
        ></div>
        <div
          class="color"
          :class="!currentActivity.colour ? 'default' : ''"
          v-if="!currentActivity || !currentActivity.colour"
        ></div>

        <h2 v-if="!currentActivity || !currentActivity.working_title">
          New {{ typeTitle }}
        </h2>
        <h2 v-if="currentActivity.working_title">
          {{ currentActivity.working_title }}
          <span
            class="d-inline-block preview-shortcut cursor-pointer pt-1"
            @click="previewActivityMember"
            alt="Preview Member"
          >
            <img :src="altLinkIcon" />
          </span>
        </h2>
        <span v-if="!currentActivity.id"><i>(unsaved)</i></span>
        <div class="status-badge" v-if="currentActivity.status">
          <span>{{
            currentActivity.status == "approved"
              ? "PAUSED"
              : currentActivity.status
          }}</span>
        </div>
      </div>
      <div class="save d-flex align-items-center">
        <b-button
          variant="primary px-4 py-3"
          @click="createActivity()"
          v-if="!currentActivity.id"
          :disabled="
            !currentActivity.working_title ||
            !currentActivity.colour ||
            !currentActivity.series
              ? true
              : false
          "
          >SAVE DRAFT</b-button
        >
        <p
          v-if="
            currentActivity.id &&
            currentActivity.status != 'produced' &&
            currentActivity.status != 'published' &&
            currentActivity.status != 'approved'
          "
        >
          Some information (<b-icon icon="exclamation-triangle-fill"></b-icon>)
          need to be filled before you’ll be able to move to the next stage.
        </p>

        <b-button
          variant="primary px-4 py-3"
          v-if="
            currentActivity.id &&
            currentActivity.status != 'produced' &&
            currentActivity.status != 'published' &&
            currentActivity.status != 'approved'
          "
          :disabled="
            !currentActivity.working_title ||
            (!currentActivity.has_script &&
              !currentActivity.filming_complete) ||
            !currentActivity.series ||
            !currentActivity.colour ||
            currentActivity.with_equipment == null ||
            (currentActivity.required_music &&
              currentActivity.spotify_playlist_name == '') ||
            (currentActivity.required_music &&
              currentActivity.apple_playlist_name == '')
              ? true
              : false
          "
          @click="updateActivity(statuses[currentActivity.status].key)"
          >{{ statuses[currentActivity.status].label }}</b-button
        >

        <b-dropdown
          split
          :text="dropDownTextStatus(currentActivity.status)"
          class="m-2 dropdown-button"
          variant="primary px-3 py-3"
          :disabled="
            !currentActivity.working_title ||
            (!currentActivity.has_script &&
              !currentActivity.filming_complete) ||
            !currentActivity.series ||
            !currentActivity.colour ||
            currentActivity.with_equipment == null ||
            (currentActivity.required_music &&
              currentActivity.spotify_playlist_name == '') ||
            (currentActivity.required_music &&
              currentActivity.apple_playlist_name == '')
              ? true
              : false
          "
          v-if="
            currentActivity.status == 'approved' ||
            currentActivity.status == 'produced' ||
            currentActivity.status == 'published'
          "
        >
          <b-dropdown-item
            @click="openApproval('approved')"
            v-if="currentActivity.status != 'approved'"
            >APPROVED AND PAUSE</b-dropdown-item
          >
          <b-dropdown-item
            @click="openApproval('published')"
            v-if="currentActivity.status != 'published'"
            >APPROVED AND PUBLISH</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div
      class="
        header-title
        save-container
        d-flex
        justify-content-between
        align-items-center
      "
      v-if="
        currentRoute.path.indexOf('recipe') !== -1 &&
        currentRoute.path != '/recipes'
      "
    >
      <div>
        <div class="d-flex justify-content-between">
          <img :src="chefHatIcon" class="mr-2" />
          <h2 v-if="!currentRecipe || !currentRecipe.title" class="mb-0">
            New Recipe
          </h2>
          <h2 v-if="currentRecipe.title" class="mb-0">
            {{ currentRecipe.title }}
            <span
              class="d-inline-block preview-shortcut cursor-pointer"
              @click="previewRecipeMember"
              alt="Preview Member"
            >
              <img :src="altLinkIcon" />
            </span>
          </h2>
        </div>
      </div>
      <b-button
        variant="primary px-4 py-3 no-outline"
        @click="createRecipe()"
        v-if="!currentRecipe.id"
        :disabled="!currentRecipe.title ? true : false"
        >SAVE DRAFT</b-button
      >

      <b-dropdown
        split
        :text="currentRecipe.status"
        class="m-2 dropdown-button text-uppercase"
        variant="primary px-3 py-3 no-outline button-width"
        v-if="currentRecipe.id"
        @click="updateRecipe(currentRecipe.status)"
      >
        <b-dropdown-item
          @click="updateRecipe('draft')"
          v-if="currentRecipe.status != 'draft'"
          >DRAFT</b-dropdown-item
        >
        <b-dropdown-item
          @click="updateRecipe('review')"
          v-if="currentRecipe.status != 'review'"
          >IN REVIEW</b-dropdown-item
        >
        <b-dropdown-item
          @click="updateRecipe('published')"
          v-if="currentRecipe.status != 'published'"
          >PUBLISHED</b-dropdown-item
        >
      </b-dropdown>
    </div>
  </div>
</template>
